import { forwardRef, type InputHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const inputVariants = cva('', {
  variants: {
    variant: {
      auth: css.authInput,
      code: css.codeInput,
      greyPromo: css.greyPromoInput,
    },
  },
});

interface InputProps
  extends InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {
  hasError?: boolean;
  isValid?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ variant = 'auth', hasError, isValid, ...props }, ref) => {
    return (
      <input
        ref={ref}
        {...props}
        className={cn(
          props.className,
          inputVariants({ variant }),
          hasError && css.error,
          isValid && css.valid,
        )}
      />
    );
  },
);

export { Input };
